module.exports = __webpack_public_path__ + "fonts/fa-brands-400.003231a1.eot";